import { render } from "./BlListPaginationSettings.vue?vue&type=template&id=de806f30&scoped=true"
import script from "./BlListPaginationSettings.vue?vue&type=script&lang=js"
export * from "./BlListPaginationSettings.vue?vue&type=script&lang=js"

import "./BlListPaginationSettings.vue?vue&type=style&index=0&id=de806f30&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de806f30"]])

export default __exports__